"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkPanelMotorSubtype = void 0;
exports.networkPanelMotorSubtype = { "DEALER": { "name": { "code": "DEALER", "localize": { "en": "Dealership garages", "th": "ศูนย์ซ่อมตัวแทนจำหน่าย" } } }, "CONTRACT": { "name": { "code": "CONTRACT", "localize": { "en": "Partner garages", "th": "อู่คู่สัญญา" } } } };
